var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newImage",class:{
    'newImage--centerImage': _vm.centerImage,
    'newImage--fit': _vm.fit,
    'newImage--fitContainCenter': _vm.fitContainCenter,
    'newImage--displayImage': _vm.displayImage,
  },style:(_vm.wrapperStyle)},[_c('img',{ref:"img",class:['newImage__image'],attrs:{"src":_vm.parseSrc,"width":_vm.width,"height":_vm.height,"alt":_vm.alt,"loading":_vm.loading}})])
}
var staticRenderFns = []

export { render, staticRenderFns }